export default function (hotelAvailabilities, departure) {
  function mergeHotels (hotels) {
    hotels.forEach(h => {
      if (h.code) {
        console.warn('old hotel format in use')
      }
      h.availability = hotelAvailabilities[(h.code || h.hotel.code)] || []
    })
  }

  if (hotelAvailabilities) {
    mergeHotels(departure.hotels.beforeTour)
    mergeHotels(departure.hotels.afterTour)
  }
}
